<!--popover triangle-->
<div class="iflx-popover-triangle"></div>
<!--popover body-->
<div class="iflx-popover-tooltip">
  <div class='iflx-popover-content'>
    {{'PROJECTTIME_APPROVAL_TAB_HELP'|translate}}
  </div>
</div>
